export enum UserTypes {
  USER = "User",
  ADMIN = "Admin",
  BENEFICIARY = "Beneficiary",
}
